// libraries
import styled from 'styled-components';

export const StyledOutsideCard = styled.div`
  position: relative;
  padding: 14px 20px;
  min-width: 300px;
  width: 300px;
  height: 176px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(
      115.38deg,
      #0dffae -15.48%,
      rgba(13, 255, 174, 0.34) 9.57%,
      rgba(13, 255, 174, 0) 58.82%,
      rgba(13, 255, 174, 0.49) 110.66%,
      #0dffae 146.08%
    );

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 10;
  }

  &.out-gs {
    .temp-contents {
      .temp-texts {
        .desc-wrapper {
          .desc {
            color: #969696 !important;
          }
        }
      }
    }
  }

  > h2 {
    color: var(--color-white) !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .temp-contents {
    display: flex;
    align-items: center;
    gap: 26px;
    margin-top: 20px;

    > img {
      width: 84px;
      height: 84px;
      object-fit: contain;
    }

    .temp-texts {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .temp {
        color: var(--color-white);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;

        > em {
          color: var(--color-white);
          font-size: 28px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          margin-right: 10px;
        }
      }

      .desc-wrapper {
        color: #969696;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        gap: 12px;
      }
    }
  }
`;
